// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wrapper_wrapper__FVcK4","title":"Wrapper_title__AAbId","titleSkeleton":"Wrapper_title-skeleton__gDHKg"};